export default "__VITE_ASSET__afba73a3__"